<textarea
  [formControl]="textareaControl"
  [placeholder]="watermark"
  rows="6"
></textarea>

<div class="save-indicator" *ngIf="saved">💾 Saved</div>
